module.exports = __webpack_public_path__ + "img/ic-search.088f3b4d.svg";